import { IconButton } from '@mui/material';

export const IconBtn = ({ children, icon, onClick, color, sx }) => (
  <IconButton style={{ color }} onClick={onClick} sx={sx} disableRipple>
    {icon || children}
  </IconButton>
);
